function setUtmParameters() {
  $(function () {
    const targets = ['utm_source', 'utm_medium', 'utm_campaign']

    const params = new URLSearchParams(location.search)
    for (let [key, value] of Array.from(params)) {
      if (targets.includes(key)) {
        sessionStorage.setItem(key, decodeURIComponent(value))
      }
    }
  })
}
export default setUtmParameters
